<template>
  <v-container 
    fluid 
    :class="['container-full-bg-gray', { 'customer-list--mobile': isMobile }]"
  >
    <div>      
    <MassiveChangesPopUp
      v-if="massiveDialog"
      :dialog="massiveDialog"
      :buttonsOnTop="true"
      @close-popup="cancelMassiveChanges()"
      @save-massive-changes="doMassiveChanges()"
    >
      <template #inputs>
        <app-modal-row >
          <app-modal-col>
            <p class="black--text font-weight-light text-center massive-info mb-6" >
              Seleccione el campo sobre el que quiere realizar el cambio masivo marcando el <v-checkbox hide-details class="ma-0 pa-0 check-info" readonly style="display: inline-block;"/> y seleccione o deje en blanco el valor que desee que tengan dichas facturas según el cambio a realizar.
            </p>
          </app-modal-col>
        </app-modal-row>
        <app-modal-row>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.income_accounts"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field 
                  kind="account"
                  :label="cru_label_income_accounts" 
                  v-model="cru_income_accounts"
                  :error="Boolean(cru_error_income_accounts)"
                  :disabled="!isEnabled.income_accounts"
                ></app-doc-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>

        <app-modal-row v-if="got_feature('feature_payment_move') && got_feature('feature_automatic_account_massive_changes')">
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.automatic_charge_account"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  outlined
                  v-model="cru_automatic_charge_account"
                  autocomplete="off"
                  :label="cru_label_automatic_charge_account" 
                  :items="automaticPaymentAccountTypes"
                  :disabled="!isEnabled.automatic_charge_account"
                />
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1"></app-modal-col>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.charge_account"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field
                  kind="account"
                  :label="cru_label_charge_account"
                  v-model="cru_charge_account"
                  :error="Boolean(cru_error_charge_account)"
                  :disabled="!isEnabled.charge_account"
                  hint="Únicamente aplica cuando la opción 'Sí' está activa"
                ></app-doc-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>

        <app-modal-row v-if="showMassiveChangeSuplidoAccount()">
            <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.suplido_account"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-doc-text-field 
                    kind="account"
                    :label="cru_label_suplido_account" 
                    v-model="cru_suplido_account"
                    :error="Boolean(cru_error_suplido_account)"
                    :disabled="!isEnabled.suplido_account"
                  ></app-doc-text-field>
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          </app-modal-row>

        <app-modal-row v-if="got_feature('feature_default_actividad_project_channel_in_massive_changes')">
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_actividad"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  v-if="got_feature('feature_actividad_selector') && activities.length > 0"
                  :label="cru_label_default_actividad"
                  v-model="cru_default_actividad"
                  :items="activities"
                  item-value="code"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_actividad)"
                  :disabled="!isEnabled.default_actividad"
                />
                <app-doc-text-field
                  v-else
                  kind="string"
                  v-model="cru_default_actividad"
                  :label="cru_label_default_actividad"
                  :error="Boolean(cru_error_default_actividad)"
                  :disabled="!isEnabled.default_actividad"
                />
              </app-modal-col>
              <app-modal-col cols="1"></app-modal-col>
            </app-modal-row>
          </app-modal-col>
          <app-modal-col cols="6" v-if="got_feature('feature_default_project_channel_in_third') && feature_document_projects && hasMasterPermission('project')">
            <app-modal-row>
              <app-modal-col cols="1"></app-modal-col>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_project"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_project"
                  v-model="cru_default_project"
                  :items="projects"
                  item-value="id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_project)"
                  :disabled="!isEnabled.default_project"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>

        </app-modal-row>
        
        <app-modal-row>
          <app-modal-col cols="6" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_channel') && hasMasterPermission('channel')">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_channel"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_channel"
                  v-model="cru_default_channel"
                  :items="channels"
                  item-value="channel_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_channel)"
                  :disabled="!isEnabled.default_channel"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>

          <app-modal-col cols="6" v-if="got_feature('feature_default_section_in_third') && got_feature('feature_sections') && hasMasterPermission('section')">
            <app-modal-row>
              <app-modal-col cols="1"></app-modal-col>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_section"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_section"
                  v-model="cru_default_section"
                  :items="sections"
                  item-value="section_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_section)"
                  :disabled="!isEnabled.default_section"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>

        <app-modal-row>
          <app-modal-col cols="6" v-if="got_feature('feature_default_delegation_in_third') && got_feature('feature_delegations') && hasMasterPermission('delegation')">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_delegation"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_delegation"
                  v-model="cru_default_delegation"
                  :items="delegations"
                  item-value="delegation_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_delegation)"
                  :disabled="!isEnabled.default_delegation"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>

          <app-modal-col cols="6" v-if="got_feature('feature_default_department_in_third') && got_feature('feature_departments') && hasMasterPermission('department')">
            <app-modal-row>
              <app-modal-col cols="1"></app-modal-col>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.default_department"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  :label="cru_label_default_department"
                  v-model="cru_default_department"
                  :items="departments"
                  item-value="department_id"
                  item-text="name"
                  :clearable="true"
                  :error="Boolean(cru_error_default_department)"
                  :disabled="!isEnabled.default_department"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>

        <app-modal-row>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.zip_code"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_zip_code" 
                  v-model="cru_zip_code"
                  :error="Boolean(cru_error_zip_code)"
                  :disabled="!isEnabled.zip_code"
                ></app-doc-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1" />
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.city"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_city" 
                  v-model="cru_city"
                  :error="Boolean(cru_error_city)"
                  :disabled="!isEnabled.city"
                ></app-doc-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
        </app-modal-row>

        <app-modal-row>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.province"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_province"  
                  v-model="cru_province"
                  :error="Boolean(cru_error_province)"
                  :disabled="!isEnabled.province"
                ></app-doc-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-col>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1" />
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.country"
                  :hide-details="true"
                  class="pa-0"
                ></v-checkbox>
              </app-modal-col>
              <app-modal-col cols="10">
                <app-autocomplete
                  outlined
                  v-model="cru_country"
                  autocomplete="off"
                  :label="cru_label_country" 
                  :items="autocompleteCountryItems"
                  :disabled="!isEnabled.country"
                />
              </app-modal-col>
            </app-modal-row>            
          </app-modal-col>
        </app-modal-row>
        <app-modal-row >
          <app-modal-col cols="6">
              <app-modal-row>
                <app-modal-col cols="1">
                  <v-checkbox
                    v-model="isEnabled.type"
                    :hide-details="true"
                    class="pa-0"
                  ></v-checkbox>
                </app-modal-col>
                <app-modal-col cols="10">
                  <app-autocomplete
                    autocomplete="off"
                    :label="cru_label_type"  
                    v-model="cru_type"
                    :items="thirdTypeTypes"
                    :readonly="false"  
                    class="autocomplete-input pa-0"
                    :disabled="!isEnabled.type"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-col>
          <app-modal-col cols="6">
            <app-modal-row>
              <app-modal-col cols="1"/>
              <app-modal-col cols="1">
                <v-checkbox
                  v-model="isEnabled.notes"
                  :hide-details="true"
                  class="pa-0"
                />
              </app-modal-col>
              <app-modal-col cols="10">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_notes" 
                  v-model="cru_notes"
                  :error="Boolean(cru_error_notes)"
                  :disabled="!isEnabled.notes"
                />
              </app-modal-col>
            </app-modal-row>            
          </app-modal-col>
        </app-modal-row>

        <v-divider class="my-4" />

        <app-modal-row>
          <v-checkbox
            v-model="isEnabled.types"
            :hide-details="true"
            label="Posición fiscal"
            class="pa-0"
          ></v-checkbox>
        </app-modal-row>
        <app-modal-row class="mt-1">
          <app-modal-col cols="12">
            <v-radio-group v-model="selectedFiscal" :key="selectedFiscal" :disabled="!isEnabled.types">
              <app-modal-row>
                <app-modal-col cols="4" class="align-center pr-1">
                  <div @click="toggleFiscal">
                    <v-radio value="inversion_sujeto_pasivo_iva" :label="cru_label_inversion_sujeto_pasivo_iva"  />
                  </div>
                  <div @click="toggleFiscal">
                    <v-radio value="inversion_sujeto_pasivo_igic" :label="cru_label_inversion_sujeto_pasivo_igic" />
                  </div>
                  <div @click="toggleFiscal">
                    <v-radio
                        value="apl_re_0"
                        :label="cru_label_apl_re_0"
                        :disabled="!isEnabled.types || !got_feature('feature_apl_re_0')"
                    />
                  </div>
                </app-modal-col>
                <app-modal-col cols="4" class="align-center pr-1">
                  <div @click="toggleFiscal">
                    <v-radio value="intracomunitario" :label="cru_label_intracomunitario" />
                  </div>
                  <div @click="toggleFiscal">
                    <v-radio value="extracomunitario" :label="cru_label_extracomunitario" />
                  </div>
                </app-modal-col>
                <app-modal-col cols="4" class="align-center">
                  <div @click="toggleFiscal">
                    <v-radio
                        value="dry_0_percent"
                        :label="cru_label_dry_0_percent"
                        :disabled="!isEnabled.types || !(feature_no_sujeta || got_feature('feature_exenta_no_sujeta'))"
                    />
                  </div>
                  <div @click="toggleFiscal">
                    <v-radio
                        value="no_sujeta"
                        :label="cru_label_no_sujeta"
                        :disabled="!isEnabled.types || !(feature_no_sujeta || got_feature('feature_exenta_no_sujeta'))"
                    />
                  </div>
                </app-modal-col>
              </app-modal-row>
            </v-radio-group>
            </app-modal-col>
            <app-modal-col cols="4">
              <app-autocomplete
                  outlined hide-details
                  autocomplete="off"
                  :label="cru_label_intracomunitario_type"
                  v-model="cru_intracomunitario_type"
                  :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                  :readonly="false"
                  class="autocomplete-input pa-0"
                  @change="areParamsChanged=true"
                  :background-color="Boolean(cru_error_intracomunitario_type)?'#ff9898':'#ffffff'"
                  :disabled="!isEnabled.types"
                  v-if="((selectedFiscal === 'intracomunitario' && feature_intra_type) || (selectedFiscal === 'extracomunitario' && (feature_extra_type || feature_extracomunitario_type)))"
              />
          </app-modal-col>
        </app-modal-row>

      </template>
    </MassiveChangesPopUp>

    <!-- <v-dialog v-model="massiveDialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="headline">
          Cambios Masivos
        </v-card-title>
        <v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="massiveDialog = False">Cancelar</v-btn>
          <v-btn color="primary darken-1" text @click="doMassiveChanges()">Guardar Cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <ListObject
      :objectType="objectType"
      :url="url"
      :selectRow="selectRow"
      :headers="customerdbListHeadersUser"
      :create="create"
      :canCreate="!got_feature('feature_not_create_thirds_and_masters')"
      :filtersData="filtersData"
      :deleteMsg="deleteMsg"
      :errorMsg="errorMsg"
      :rowsNumber="rowsPerPage"
      @rowsPerPage="setRowsNumber"
      :generateFilters="genFilters"
      :cleanFilters="cleFilters"
      :refreshData="refresh"
      :filters="currentFilters"
      :selectionableRows="true"
      :selectedAction="selected_action"
      @item-selected="send_filters = false"

      @selected-action="selectedAction"
      @job-done="jobDone"
      :actions="getActions"
      :loadingAction="loadingAction"
      :disabledActions="selected.length==0"
    >
      <template v-slot:header-prefix>
        <v-btn
          v-if="currentCompany"
          icon
          @click="backToDocuments()"
          color="primary"
        >
          <AppIcon :src="require('@/assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
        </v-btn>
      </template>
      <template v-slot:actions>
        <!-- <action-selector 
          :actions="getActions" 
          :loading="loadingAction"
          :disabled="selected.length==0"
          @do-action="doAction"
          @job-done="jobDone"
          @selected-action="selectedAction"
        ></action-selector>
        <div class="flex-grow-1"></div> -->
      </template>
      <template v-slot:select_all>
        <v-checkbox
          v-if="show_select_all"
          :label="'Aplicar en los ' + length_items + ' clientes'"
          class="ma-0 pt-2 pl-4 pb-2 pr-0" 
          v-model="send_filters"
          hide-details
        ></v-checkbox>
      </template>
      <template v-slot:filters>
        <v-row>
          <v-col cols="12">
            <div>
              <v-text-field 
                autocomplete="off" 
                :label="cus_filters_customer__name__icontains.label" 
                v-model="cus_filters_customer__name__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-text-field 
                autocomplete="off" 
                :label="cus_filters_customer__nif__icontains.label" 
                v-model="cus_filters_customer__nif__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-text-field 
                autocomplete="off" 
                :label="cus_filters_income_account__icontains.label" 
                v-model="cus_filters_income_account__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-text-field 
                autocomplete="off" 
                :label="cus_filters_debit_account__icontains.label" 
                v-model="cus_filters_debit_account__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-checkbox
                v-if="hasEInvoiceContract"
                v-model="cus_filters_einvoice_customer_value"
                :label="cus_filters_einvoice_customer.label"
                hide-details
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>
      </template>
    </ListObject>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ListObject from '../components/ListObject.vue';
import ActionSelector from '../components/ActionSelector.vue';
import MessagePopup from '../components/MessagePopup.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import MassiveChangesPopUp from '../components/MassiveChangesPopUp.vue';
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import { jobs } from '../api/jobs.js';
import { client, query_dispatcher } from "@/api/client";

export default {
  components: {
    ListObject,
    ActionSelector,
    MessagePopup,
    AppAutocomplete,
    AppDocTextField,
    AppModalCol,
    AppModalContainer,
    AppModalRow,
    MassiveChangesPopUp,
  },
  
  data() {
    return {
      objectType: "Clientes",
      url: "customers/",
      create: "create-customer",
      update: "customer-update",
      filtersData: [
        {
          'name': 'customer__name__icontains', 
          'label': 'Nombre de cliente'
        },
        {
          'name': 'customer__nif__icontains', 
          'label': 'CIF de cliente'
        },
        {
          'name': 'income_account__icontains', 
          'label': 'Cuenta de Ingresos'
        },
        {
          'name': 'debit_account__icontains', 
          'label': 'Cuenta'
        },
        {
          'name': 'einvoice_customer', 
          'label': 'Cliente factura electrónica'
        }

      ],
      // deleteMsg: "You will remove this customer. Are you sure?",
      // errorMsg: "It was not possible to delete this customer.",
      deleteMsg: "¿Estás seguro de que quieres borrar este cliente?",
      errorMsg: "No se ha podido borrar este cliente.",
      ids: [],
      loadingAction: false,
      documentName: '',
      documentFormat: '',
      message: '',
      show_message: false,
      message_actions: [{ 'action_text': 'OK', 'emit': 'close-message', 'prin': true }],
      massiveDialog: false,

      isEnabled: {
        'income_accounts': false,
        'automatic_charge_account': false,
        'charge_account': false,
        'types': false,
        'zip_code': false,
        'default_actividad': false, 
        'default_project': false, 
        'default_channel': false,
        'default_section': false,
        'default_delegation': false,
        'default_department': false,
        'city': false,
        'province': false,
        'country': false,
        'notes': false,
        'review': false,
        'suplido_account': false,
        'type': false

      },
      selected_action: '',
      send_filters: false,
      selectedFiscal: '',
      hasEInvoiceContract: false,
    }
  },
  computed: {
    ...mapState(['currentCompany',]),
    ...mapGetters({
      rowsPerPage: "customerRowsPerPage",
      getCountryByCode: 'countries/getCountryByCode', 
      getCountries: 'countries/getCountries',
      got_feature:'got_feature',
      customerdbListHeadersUser: 'documents/customerdbListHeadersUser',
      isMobile: 'is_mobile',
    }),
    ...mapFields({
      page: 'objectListOptions.page',
      selected: 'objectListSelected',
      downloadJobState: 'downloadJobState',
      asyncJobId: 'asyncJobId',
      items: 'objectListItems',
      length_items: 'objectListItemsLength',
      activities: 'activities',
      projects: 'projects',
      channels: 'channels',
      sections: 'sections',
      delegations: 'delegations',
      departments: 'departments',
      automaticPaymentAccountTypes: 'automaticPaymentAccountTypes',
      thirdTypeTypes: 'thirdTypeTypes',
    }),
    ...mapFields('cru', {
      actualScreen: 'actualScreen',
      currentFilters: 'currentFilters.customerListValues',
      actions: 'actions.customerListValues', 
    }), 
    ...mapFields('cru',vuexPrefix('cus_filters_',['customer__name__icontains', 'customer__nif__icontains', 'income_account__icontains', 'debit_account__icontains', 'einvoice_customer'],'filtersData.customerListValues.')),
    ...mapFields('cru',vuexPrefix2('cus_filters_', ['value'], 'filtersData.customerListValues.', ['customer__name__icontains', 'customer__nif__icontains', 'income_account__icontains', 'debit_account__icontains', 'einvoice_customer'])),
  
  
    ...mapFields('cru',vuexPrefix('cru_',[
      'income_accounts', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'zip_code', 'city', 'province', 'country', 'notes', 
      'review', 'automatic_charge_account', 'charge_account', 'no_sujeta', 'intracomunitario_type', 'apl_re_0', 'dry_0_percent', 'default_actividad', 'default_project', 'default_channel', 
      'suplido_account', 'type', 'default_section', 'default_delegation', 'default_department'
    ],'screenValues.customerScreenValues.')),
    ...mapFields('cru',vuexPrefix('cru_error_',[
      'income_accounts', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'zip_code', 'city', 'province', 'country', 
      'notes', 'review', 'automatic_charge_account', 'charge_account', 'no_sujeta', 'intracomunitario_type', 'default_actividad', 'default_project', 'default_channel', 
      'suplido_account', 'type', 'default_section', 'default_delegation', 'default_department'
    ],'screenErrors.customerScreenValues.')),
    ...mapFields('cru', vuexPrefix('cru_errors_',['customerScreenValues'],'screenErrors.')),
    ...mapFields('cru',vuexPrefix('cru_label_',[
      'income_accounts', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'zip_code', 'city', 'province', 'country', 
      'notes', 'review', 'automatic_charge_account', 'charge_account', 'no_sujeta', 'intracomunitario_type', 'apl_re_0', 'dry_0_percent', 'default_actividad', 'default_project', 'suplido_account', 'type',
      'default_channel', 'default_section', 'default_delegation', 'default_department'
    ],'inputLabels.')),
    ...mapFields('me',vuexPrefix('',['feature_no_sujeta', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_document_projects'],'userData.available_features.')),
    ...mapFields('documents', ['customerdbListHeadersUser']),
    ...mapFields('me', ['userData']),

    autocompleteCountryItems: function() {
      return this.getCountries.map((country_code) => {
        let country = this.getCountryByCode(country_code);
        return {"text": country.name, "value": country.code}
      });
    },
    show_select_all() {
      let show = false;
      let length_selected = this.selected.length;
      let items_lenth = this.items.length
      if (items_lenth == length_selected) {
        if (['export'].includes(this.selected_action)) {
          show = true;
        }
      }
      return show;
    },
    getActions() {
      let actions = {};
      for (let i in this.actions) {
        let group = this.actions[i]['group'];
        if (!actions.hasOwnProperty(group)) {
          actions[group] = [];
        }
        if (!this.actions[i].hasOwnProperty('permission') || !this.got_feature('feature_not_create_thirds_and_masters')) {
          actions[group].push(this.actions[i]);
        }
      }
      Object.keys(actions).forEach(function(key) {
        if (actions[key].length == 0) {
          delete actions[key];
        }
      });
      return actions;
    },
  },

  created() {
    this.actualScreen = 'customerListValues';
    this.downloadJobState = 'done';
    this.asyncJobId = 0;
    this.getCountriesList();
    this.cancelMassiveChanges();
  },

  methods: {
    ...mapActions(["setCustomerRowsPerPage"]),
    ...mapActions({ 
      refreshData: "refreshData",
      generateFilters: "cru/generateFilters",
      cleanFilters: "cru/cleanFilters",
      exportCru: "cru/exportCru",
      massiveUpdate: "cru/massiveUpdateObject",
      getCountriesList: "countries/getCountries",
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
    }),
    selectRow(data) {
      var params = { name: this.update, params: { 'customer': data.id } };
      this.$router.push(params);
    },
    setRowsNumber(rowsNumber) {
      this.setCustomerRowsPerPage(rowsNumber)
    },
    genFilters() {
      this.generateFilters().then(() => {
        this.page = 1;
        this.refresh();
      });
    },
    cleFilters() {
      this.cleanFilters().then(() => {
        this.page = 1;
        this.refresh();
      });
    },
    refresh() {
      this.refreshData(this.currentFilters);
    },
    showMessage(m, icon){
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }

      if (icon) {
        modal.icon = icon
      }

      this.setMessageModal(modal)
    },
    doAction() {
      this.ids = [];
      for (let i in this.selected) {
        this.ids.push(this.selected[i].id)
      }
      if (this.selected_action == 'export') {
        this.exportCru({ url: 'export_customers/', ids: this.ids, send_filters: this.send_filters, currentCompany: this.currentCompany }).then(response=>{
            this.asyncJobId = response.data['AsyncJob'];
            this.documentName = "clientes";
            this.documentFormat = "xlsx";
            this.downloadJobState = "running";
        }).catch(err=>{
          this.showMessage('Algo ha ido mal.')
          console.error(err)
        })       
      } else if (this.selected_action == 'delete') {
        this.setMessageModal({
          text: 'Se borraran los clientes seleccionados.',
          showQuestion: true,
          textQuestion: '¿Está seguro?',

          textConfirmButton: 'Sí',
          actionConfirmButton: () => { this.deleteItems(false) },
        
          showCancelButton: true,
          textCancelButton: 'No',
          actionCancelButton: this.noDeleteItems
        })
      } else if (this.selected_action == 'massive_change') {
        this.massiveDialog = true;
      } else {
        console.debug('Not Implemented');
      }
    },
    async jobDone() {
      if (this.selected_action == 'export') {
        const response = await jobs.getJobFile({ id: this.asyncJobId });
        let fileURL = response.data.url
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", this.documentName + "." + this.documentFormat);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },
    selectedAction(actionId) {
      this.selected_action = actionId;
      this.doAction();
    },
    deleteItems(force) {
      this.closeMessageModal()
      this.loadingAction = true;
      this.exportCru({ url: 'delete_customers/', ids: this.ids, force: force }).then(response=>{
        this.loadingAction = false;
        this.selected = [];
        let errs = response.data['errors'];
        let can_force = response.data['can_force'];
        let msg = '';
        let isHtml = false;
        let icon;
        if (errs.length) {
          for (let i in errs) {
            msg = msg + errs[i] + '<br/>';
          }
          isHtml = true;
        } else {
          msg = 'Clientes borrados con éxito.';
          icon = 'mdi-information-outline'
        }

        if (can_force) {
          this.setMessageModal({
            isHtml: isHtml,
            text: msg,
            textConfirmButton: 'Sí',
            actionConfirmButton: this.forceDelete,

            showCancelButton: true,
            textCancelButton: 'No',
            actionCancelButton: this.noForceDelete
          })
        } else {
          this.selected = [];
          this.setMessageModal({
            isHtml: isHtml,
            text: msg,
            textConfirmButton: 'Aceptar',
            actionConfirmButton: this.closeMessageModal,
            icon: icon,
          })
        }
        this.refresh();
      }).catch(err=>{
        this.showMessage('Algo ha ido mal.')
        this.loadingAction = false;
        console.error(err);
      });
    },
    noDeleteItems() {
      this.selected = [];
      this.closeMessageModal()
    },
    noForceDelete() {
      this.closeMessageModal()
      this.noDeleteItems();
    },
    forceDelete() {
      this.closeMessageModal()
      this.deleteItems(true);
    },
    showMassiveChangeSuplidoAccount() {
      if (this.got_feature('feature_suplido_account') && this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type.params) {
        return !this.currentCompany.companydb_type.params.hasOwnProperty('hide') || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('suplido_account'));
      }
      return false;
    },
    
    cancelMassiveChanges() {
      this.massiveDialog = false;
      this.cru_errors_customerScreenValues = {};

      this.cru_income_accounts = '';
      this.cru_intracomunitario_type = '';
      this.cru_default_actividad = '';
      this.cru_default_project = '';
      this.cru_default_channel = null;
      this.cru_default_section = null;
      this.cru_default_delegation = null;
      this.cru_default_department = null;
      this.cru_zip_code = '';
      this.cru_city = '';
      this.cru_province = '';
      this.cru_country = '';
      this.cru_notes = '';
      this.cru_review = false;
      this.cru_automatic_charge_account = '';
      this.cru_charge_account = '';
      this.cru_suplido_account = '';
      this.cru_type = '';
      this.selectedFiscal = '';

      let keys = Object.keys(this.isEnabled);
      for (let i in keys) {
        this.isEnabled[keys[i]] = false;
      } 
    },

    doMassiveChanges() {
      this.loadingAction = true;
      let params = {};
      if (this.isEnabled.income_accounts) {
        params['income_accounts'] = this.cru_income_accounts;
      }
      if (this.isEnabled.types) {
        params['inversion_sujeto_pasivo_iva'] = false;
        params['inversion_sujeto_pasivo_igic'] = false;
        params['intracomunitario'] = false;
        params['extracomunitario'] = false;
        params['no_sujeta'] = false;
        params['dry_0_percent'] = false;
        params['apl_re_0'] = false;

        if (this.selectedFiscal){
          params[this.selectedFiscal] = true;
        }

        if (this.selectedFiscal === 'intracomunitario' && this.cru_intracomunitario_type) {
          params['intracomunitario_type'] = this.cru_intracomunitario_type;
        }
      }
      if (this.isEnabled.default_actividad) {
        params['default_actividad'] = this.cru_default_actividad;
      }
      if (this.isEnabled.default_project) {
        params['default_project'] = this.cru_default_project;
      }
      if (this.isEnabled.default_channel) {
        params['default_channel'] = this.cru_default_channel;
      }
      if (this.isEnabled.default_section) {
        params['default_section'] = this.cru_default_section;
      }
      if (this.isEnabled.default_delegation) {
        params['default_delegation'] = this.cru_default_delegation;
      }
      if (this.isEnabled.default_department) {
        params['default_department'] = this.cru_default_department;
      }
      if (this.isEnabled.zip_code) {
        params['zip_code'] = this.cru_zip_code;
      }
      if (this.isEnabled.city) {
        params['city'] = this.cru_city;
      }
      if (this.isEnabled.province) {
        params['province'] = this.cru_province;
      }
      if (this.isEnabled.country) {
        params['country'] = this.cru_country;
      }
      if (this.isEnabled.notes) {
        params['notes'] = this.cru_notes;
      }
      if (this.isEnabled.review) {
        params['review'] = this.cru_review;
      }

      if (this.isEnabled.automatic_charge_account) {
        params['automatic_charge_account'] = this.cru_automatic_charge_account;
      }
      if (this.isEnabled.charge_account) {
        params['charge_account'] = this.cru_charge_account;
      }
      if (this.isEnabled.suplido_account) {
        params['suplido_account'] = this.cru_suplido_account;
      }
      if (this.isEnabled.type) {
        params['type'] = this.cru_type;
      }

      this.massiveUpdate({ 
        'url': 'massive_update_customerdb/', 
        'ids': this.ids,
        'params': params, 
        'currentCompany': this.currentCompany 
      }).then(res => {
        if ('error' in res.data) {
          this.showMessage(res.data['error']);
        }
        else {
          this.cancelMassiveChanges();
          this.showMessage('Cambios realizados con éxito.', 'mdi-information-outline');
          this.refreshData(this.currentFilters);
        }
        this.loadingAction = false;
      }).catch(err => {
        console.error(err);
        this.showMessage('Algo ha ido mal.');
        this.loadingAction = false;
      });
  
    },

    backToDocuments() {
      this.$router.push({ name: 'document-list', params: { companydb_id: this.currentCompany.id } });
    },

    toggleFiscal(){

      if (this.selectedFiscal === this.lastSelectedFiscal) {
        this.selectedFiscal = undefined;
      }
    },
    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && 
      this.currentCompany.companydb_type.params.show.includes(master);
    }
  },

  async mounted() {
    if (this.currentCompany && this.userData) {
      let res = await query_dispatcher.dispatch('check.user.has.active.envoice.contract', { user_id: this.userData.id, company_id: this.currentCompany.id })
      this.hasEInvoiceContract = res['company']
    }    
  },

  watch: {
    selectedFiscal() {
      setTimeout(() => {
        this.lastSelectedFiscal = this.selectedFiscal;
      })
    },
  },
};
</script>


<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>

<!-- Mobile CustomerList -->
<style>
.customer-list--mobile {
  overflow-y: hidden !important;

  padding: 0 !important;

  .v-card__title {
    padding: 0 !important;

    .col{
      padding: 0 !important;
    }

    .flex-grow-1.col {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }

  thead > tr > th{
      border: 1px solid #ccc;
      border-radius: 0 !important;
  }

  .container {
      padding: 0 !important;
  }

  .app-col--no-input-fields-above{
      padding: 0 !important;
  }

  .v-data-table__wrapper {
    min-height: calc(100vh - 220px); 
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    margin-bottom: 2px !important;
    border-radius: 0 !important;

    table {
      tbody > tr {
        td:first-child {
          background-color: #5C3D8F !important;

          .theme--light.v-icon{
            color: white !important;
          }
        }
        td {
          border: 1px solid gray;
        }
      }
    }
  }

  .v-data-footer{
    margin: 0 !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    .v-data-footer__select{
      margin: 0 !important;
      display: none !important;
    }
  }

  .v-card__text{
    padding: 0 !important;
  }

  .v-data-table-header-mobile__wrapper{
    width: fit-content;
    min-height: 8vh
  }

  .v-text-field{
    padding-top: 0 !important; 
    margin-top: 0 !important;
  }

  .v-input{
    margin-top:16px !important;
  }
}
</style>